import * as Sentry from "@sentry/react";

import { ENV } from "@/constants/env";

Sentry.init({
    dsn: ENV.SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllInputs: false,
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        "localhost",
        "127.0.0.1",
        "https://phone.elithair.tech/",
        /^https:\/\/svc\.elithair\.tech\/api/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: ENV.RELEASE_VERSION,
    environment: ENV.DEV ? "development" : "production",
    enabled: !ENV.DEV,
});
